import './index.css';
import { jsx } from 'react/jsx-runtime';

var styles = {"translate-guard":"magritte-translate-guard___vTvRy_0-1-13","translateGuard":"magritte-translate-guard___vTvRy_0-1-13"};

const TranslateGuard = ({ useSpan, ...props }) => {
    if (!props.children) {
        return null;
    }
    if (useSpan) {
        return jsx("span", { ...props });
    }
    return jsx("div", { className: styles['translate-guard'], ...props });
};

export { TranslateGuard };
//# sourceMappingURL=TranslateGuard.js.map
